import React from 'react'
import industry1 from '../images/tk-1.png'
import industry2 from '../images/tk-2.png'
import industry3 from '../images/tk-3.png'
import industry4 from '../images/tk-4.png'
import industry5 from '../images/tk-5.png'
import industry6 from '../images/tk-6.png'
import industry7 from '../images/tk-7.png'
import industry8 from '../images/tk-8.png'
import hf1 from '../images/hf-1.png'
import hf2 from '../images/hf-2.png'
import hf3 from '../images/hf-3.png'
import hf4 from '../images/hf-4.png'
import '../style/tkab.css'

const TalkAbMe = () => {
    return (
        <>
            <section id='bgTk'>
                <div className='container'>
                    <div className='ok' style={{ display: 'flex', justifyContent: 'center', marginTop: '75px', paddingTop: '25px' }} data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true'>
                        <h3 style={{ padding: '7px' }}>Talk to Me About</h3>
                    </div>
                    <div className='row' style={{ marginTop: '50px' }}>
                        <div className='col' style={{ textAlign: 'center' }}>
                            <img src={industry1} width={'80px'} height={'80px'} alt="industrylogo" />
                            <h5 style={{ marginTop: '15px' }}>NLP & Mind Mastery</h5>
                        </div>
                        <div className='col' style={{ textAlign: 'center' }}>
                            <img src={industry2} width={'80px'} height={'80px'} alt="industrylogo" />
                            <h5 style={{ marginTop: '15px' }}>Profitable Business</h5>
                        </div>
                        <div className='col' style={{ textAlign: 'center' }}>
                            <img src={industry4} width={'80px'} height={'80px'} alt="industrylogo" />
                            <h5 style={{ marginTop: '15px' }}>Success & Achievement</h5>
                        </div>
                        <div className='col' style={{ textAlign: 'center' }}>
                            <img src={industry3} width={'80px'} height={'80px'} alt="industrylogo" />
                            <h5 style={{ marginTop: '15px' }}>Business Growth</h5>
                        </div>
                    </div>
                    <div className='row' style={{ marginTop: '50px', paddingBottom: '50px' }}>
                        <div className='col' style={{ textAlign: 'center' }}>
                            <img src={industry5} width={'80px'} height={'80px'} alt="industrylogo" />
                            <h5 style={{ marginTop: '15px' }}>Visual Presentation</h5>
                        </div>
                        <div className='col' style={{ textAlign: 'center' }}>
                            <img src={industry6} width={'80px'} height={'80px'} alt="industrylogo" />
                            <h5 style={{ marginTop: '15px' }}>Entreprenuership</h5>
                        </div>
                        <div className='col' style={{ textAlign: 'center' }}>
                            <img src={industry7} width={'80px'} height={'80px'} alt="industrylogo" />
                            <h5 style={{ marginTop: '15px' }}>Productivity</h5>
                        </div>
                        <div className='col' style={{ textAlign: 'center' }}>
                            <img src={industry8} width={'80px'} height={'80px'} alt="industrylogo" />
                            <h5 style={{ marginTop: '15px' }}>Set Mindset</h5>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className='container' style={{ marginTop: '75px' }} id='expCard'>
                    <h4 style={{ color: "#00415d", textAlign: 'center' }}>Hire us For</h4>
                </div>
            </section>
            <section>
                <div className='container' style={{ marginTop: '50px' }} >
                    <div className='row' id='expCardR'>
                        <div className='col-sm' id='colCardR'>
                            <div className="card" style={{ width: "18rem", border: '0px' }}>
                                <img src={hf1} style={{ borderRadius: "0px" }} className="card-img-top" alt="..." />
                                <div className="card-body" style={{ textAlign: 'center' }}>
                                    <h4 className="card-title" style={{ color: 'black' }}>Keynote Speaking</h4>
                                    <p style={{ fontSize: '15px' }}>
                                        Seeking a speech that'll ignite minds and leave your teams buzzing with empowerment and transformation?
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm' id='colCardR'>
                            <div className="card" style={{ width: "18rem", border: '0px' }}>
                                <img src={hf2} style={{ borderRadius: "0px" }} className="card-img-top" alt="..." />
                                <div className="card-body" style={{ textAlign: 'center' }}>
                                    <h4 className="card-title" style={{ color: 'black' }}>Workshops</h4>
                                    <p style={{ fontSize: '15px' }}>
                                        Ready to plunge into a theme headfirst with interactive exercises, coaching techniques, and tools that'll spark lasting change?
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm' id='colCardR'>
                            <div className="card" style={{ width: "18rem", border: '0px' }}>
                                <img src={hf3} style={{ borderRadius: "0px" }} className="card-img-top" alt="..." />
                                <div className="card-body" style={{ textAlign: 'center' }}>
                                    <h4 className="card-title" style={{ color: 'black' }}>Media Spokesperson</h4>
                                    <p style={{ fontSize: '15px' }}>
                                        Need a voice that resonates with your values and drives positive change across the globe?
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TalkAbMe
